export class SubscriptionFeed {

  constructor(
    public method?: string,
    public args?: unknown[]
  ) {
  }
}
